import { V } from '../common/Layout';
import FormButtons from '../common/form/FormButtons';
import { cloneDeep } from 'lodash';
import { FormProvider } from '../common/form/FormContext';
import React, { useContext, useEffect, useState } from 'react';
import { AvailableTypeEnum, Field, fieldEditors, Type, typeListeners, useTypeValidationRules } from './attributes';
import { useLazyQuery } from '@apollo/client';
import { client, termsetListQuery } from '../supply/termset/termset';
import { UserContext } from '../common/auth/UserContext';
import { FETCH_POLICY_CONFIG } from '../common/constants/constants';

type FieldEditorProps = {
    type: Type;
    onAdd: (field: Field) => void;
    onCancel: () => void;
};
export const INITIAL_FORM_STATE = {
    newTermset: [],
    termset: '',
    isMultiSelect: false,
    decimalsNumber: 2,
    label: '',
    group: ''
};

export default (props: FieldEditorProps) => {
    const { type, onAdd, onCancel } = props;
    const [value, setValue] = useState({ ...cloneDeep(INITIAL_FORM_STATE) });
    const Editor = fieldEditors[type.fieldType];
    const listeners = typeListeners[type.fieldType];
    const { activeOrganizationAccount } = useContext(UserContext);

    const [getData, { data: termsetsData }] = useLazyQuery(termsetListQuery, {
        client: client,
        context: {
            headers: {
                ownerId: activeOrganizationAccount
            }
        },
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy,
        notifyOnNetworkStatusChange: false
    });

    const { typeValidationRules } = useTypeValidationRules(type, value);

    useEffect(() => {
        if (type.fieldType === AvailableTypeEnum.termset) {
            getData();
        }
    }, [type, getData]);

    return (
        <FormProvider
            validationRules={typeValidationRules}
            state={value}
            setState={setValue}
            listeners={listeners}
            expandedSections={['attribute']}
            allowMultipleExpansion={false}
        >
            <V>
                <Editor termsetsData={termsetsData} />
                <FormButtons
                    containerSx={{ pr: 2, pb: 2 }}
                    onClickCancel={() => {
                        setValue(undefined);
                        onCancel();
                    }}
                    onClickSave={() => {
                        //@ts-ignore
                        const newField: Field = {
                            ...cloneDeep(type),
                            ...cloneDeep(value)
                        };
                        onAdd(newField);
                        setValue(undefined);
                    }}
                />
            </V>
        </FormProvider>
    );
};
